"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromEntries = void 0;
function fromEntries(entries) {
    return [...entries].reduce((obj, [key, val]) => {
        obj[key] = val; // eslint-disable-line no-param-reassign
        return obj;
    }, {});
}
exports.fromEntries = fromEntries;
//# sourceMappingURL=utils.js.map